import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

import { environment } from '@environments/environment';

export class ApiMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        console.warn(`Missing translation for key: ${params.key}`);
        
        return `MISSING ${params.key}`;
    }
}
